import { CenterLayout } from "@/components";

import { WelcomeAssest } from "./WelcomeAsset";

export function Welcome() {
  return (
    <CenterLayout>
      <h1 className="text-[2rem] font-bold text-rdc-primary">Bienvenidos a GIRE</h1>
      <h2 className="text-[0.875rem] text-rdc-gray">Ingrese a un módulo para continuar</h2>

      <WelcomeAssest />
    </CenterLayout>
  );
}
